import { ChoiceValidator } from '../../validators';

export const validateSelection = (
	selectedOptions: Array<string>,
	validator: ChoiceValidator | undefined,
	required: boolean
): { valid: boolean; message: string } => {
	const { min, max } = validator || { min: undefined, max: undefined };
	const selectedCount = selectedOptions.length;
	let errorMessage = '';

	if (required) {
		if (selectedCount === 0) {
			errorMessage = 'Selection is required';
		}
	}

	if (typeof min === 'number' && selectedCount < min) {
		errorMessage = `Minimum selection required: ${min}`;
	}

	if (typeof max === 'number' && selectedCount > max) {
		errorMessage = `Maximum selection allowed: ${max}`;
	}

	return { valid: errorMessage === '', message: errorMessage };
};
